module.exports = __webpack_public_path__ + "img/4.88639b7c.jpg";